// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__4gTas","site":"index_site__QRcN-"};